import { DeepPartial } from "@/utils/common.util";
import mutations from "./mutations";
import actions from "./actions";
import getters from "./getters";

export interface VoipNumberPoolState {
	province: string;
	availableNumbers: string[];
	prefixes: string[];
}

export const voipNumberPoolInitialState = (): DeepPartial<VoipNumberPoolState> => {
	return {
		province: "",
		availableNumbers: [],
		prefixes: []
	};
};

const state = voipNumberPoolInitialState();
export default {
	namespaced: true,
	state,
	actions,
	mutations,
	getters
};
